<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon color="primary" dark v-bind="attrs" v-on="on">
          <v-icon>mdi-cog</v-icon>
        </v-btn>
      </template>
      <v-card :loading="loading" color="#fffdf7">
        <v-toolbar color="#ffefc0">
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Price Calculator Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text @click="doSave()" :disabled="!canSave"> Save </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card
          flat
          max-width="600"
          color=""
          class="my-3 mx-auto pa-4 grayBorder"
        >
          <div class="text-h4 my-2">Supply Calculator Defaults</div>
          <div class="caption">
            Values specified here will be used to pre-populate the prices
            calculator on new calculations.
          </div>
          <v-divider class="my-2"></v-divider>
          <v-card-text>
            <div class="d-flex flex-row justify-space-between py-1 my-2">
              <div class="font-weight-black">Shipping (Year Supply)</div>
              <v-text-field
                v-model="calcOptions.shippingYear"
                prefix="$"
                class="medNum"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </div>
            <v-divider></v-divider>

            <div class="d-flex flex-row justify-space-between py-1 my-2">
              <div class="font-weight-black">Shipping (Partial Supply)</div>
              <v-text-field
                v-model="calcOptions.shippingPartial"
                prefix="$"
                class="medNum"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </div>
            <v-divider></v-divider>

            <div class="d-flex flex-row justify-space-between py-1 my-2">
              <div>
                <div class="font-weight-black">Year Supply Discount</div>
                <div class="caption">
                  A discount to be applied for year supply purchases.
                </div>
                <!-- <v-checkbox
                  v-model="calcOptions.offerYearSupplyDiscount"
                  label="Provide a discount for buying a year supply"
                  dense
                ></v-checkbox> -->
                <!--                 
                <v-radio-group row v-model="calcOptions.yearDiscountType">
                  <v-radio label="Dollar amount" value="dollar"></v-radio>
                  <v-radio label="Percentage" value="percent"></v-radio>
                </v-radio-group>
                <v-expand-transition>
                  <div
                    v-show="calcOptions.yearDiscountType == 'percent'"
                    class="ml-2"
                  >
                    <v-checkbox
                      v-model="calcOptions.discountIncludesShipping"
                      label="Include shipping in percent discount calculation"
                    ></v-checkbox>
                    <v-checkbox
                      v-model="calcOptions.discountIncludesIns"
                      label="Apply insurance contribution before percent discount calculation"
                    ></v-checkbox>

                    <div>
                      <u>Example</u>: <br />Lenses: $300<br />Shipping: $10<br />Insurance
                      Contribution: $100<br />Year supply discount: 10%<br />
                      <b>Calculated discount</b>: {{ discountExampleFormula }} =
                      {{ discountExampleAnswer | currency }}
                    </div>
                  </div>
                </v-expand-transition> -->
              </div>

              <v-text-field
                v-model="calcOptions.yearDiscount"
                value="0.00"
                prefix="$"
                class="medNum"
                outlined
                dense
                hide-details="auto"
              ></v-text-field>
            </div>

            <v-divider></v-divider>

            <!-- <div class="d-flex flex-row justify-space-between ">
              <div class="font-weight-black">
                Year Supply Discount (Percent)<br />
                Apply year supply discount percentage<br />
                <v-radio-group v-model="calcOptions.discountIncludesShipping">
                  <v-radio label="After shipping is added"></v-radio>
                  <v-radio label="Before shipping is added"></v-radio>
                </v-radio-group>
                <v-radio-group v-model="calcOptions.discountIncludesIns">
                  <v-radio value="true"
                    label="After insurance contribution has been applied"
                  ></v-radio>
                  <v-radio value="false"
                    label="Before insurance contribution has been applied"
                  ></v-radio>
                </v-radio-group>
              </div>
              <v-text-field
                value="0.00"
                suffix="%"
                class="medNum"
                outlined
                dense
              ></v-text-field>
            </div> -->

            <div class="d-flex flex-row justify-space-between align-start py-1">
              <div class="font-weight-black columnA py-2">
                Show expected yearly cost for partial supplies
                <div class="caption">
                  This will calculate the cost required to complete a partial
                  lens supply. For example, if the patient plans to purchase a
                  6-month supply, this will show the cost of an additional 6
                  month supply.
                </div>
              </div>

              <v-checkbox
                v-model="calcOptions.showYearCost"
                :false-value="0"
                :true-value="1"
                @click="updateShowSavings()"
              ></v-checkbox>
            </div>

            <v-divider></v-divider>

            <div class="d-flex flex-row justify-space-between align-start py-1">
              <div class="font-weight-black py-2">
                Show text touting year supply savings
                <div v-show="!calcOptions.showYearCost">
                  (Only available if the above option is checked)
                </div>
                <div class="caption">
                  Text comparing the year supply price to the expected yearly
                  cost for partial supplies.<br />
                  eg) "Year supply savings: $139.99"
                </div>
              </div>
              <v-checkbox
                :disabled="!calcOptions.showYearCost"
                v-model="calcOptions.showSavings"
                :false-value="0"
                :true-value="1"
              ></v-checkbox>
            </div>

            <v-divider class="my-2"></v-divider>

            <div class="">
              <div class="font-weight-black">
                Text to add to the bottom of printed materials
              </div>
              <v-textarea
                v-model="calcOptions.appendTextToPrinted"
                outlined
                dense
              ></v-textarea>
            </div>

            <!-- <draggable v-model="items" class="d-flex flex-column" ghost-class="ghost">
              <v-card
                v-for="item in items"
                :key="item.id"
                max-width="200"
                class="pa-1 ma-1 draggableCard"
              >
                {{ item.title }}
              </v-card>
            </draggable> -->
          </v-card-text>
          <v-card-actions class="pb-4">
            <v-spacer></v-spacer>
            <v-btn depressed class="mx-3" @click="dialog = false">
              <v-icon class="mr-1" small>mdi-close</v-icon> Cancel
            </v-btn>
            <v-btn
              depressed
              color="success"
              @click="doSave()"
              :disabled="!canSave"
            >
              <v-icon class="mr-1" small>mdi-content-save</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errorSnack" :timeout="2000" color="alert"
      >There was an error updating default price settings</v-snackbar
    >
    <v-snackbar v-model="successSnack" :timeout="2000" color="success"
      >Default price settings were updated successfully</v-snackbar
    >
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import UserMixin from "@/assets/js/UserMixin";
// import draggable from "vuedraggable";
// from https://github.com/SortableJS/Vue.Draggable/blob/master/example/components/simple.vue

export default {
  name: "PriceSettingsHome",
  // components: { draggable },
  mixins: [UserMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      calcOptions: {
        // keys must match 'label' field in 'preferences_list'
        // yearDiscountType: "dollar",
        // offerYearSupplyDiscount: false,
        yearDiscount: 0, // default to 0 if offerYearSupplyDiscount = 0
        // discountIncludesShipping: true,
        // discountIncludesIns: true,
        shippingYear: 0,
        shippingPartial: 9.99,
        showYearCost: 1,
        showSavings: 1,
        appendTextToPrinted: "Please call with any questions!",
      },
      downloadedPrefs: null,
      errorSnack: null,
      successSnack: null,

      // items: [
      //   { id: 1, title: "Shipping fees" },
      //   { id: 2, title: "Insurance contribution" },
      //   { id: 3, title: "Year supply discount" },
      //   { id: 4, title: "Other adjustments" }
      // ],
    };
  },
  computed: {
    // discountExampleFormula: function () {
    //   let rtn = "10% x ($300 ";
    //   if (this.calcOptions.discountIncludesShipping) rtn += " + $10 ";
    //   if (this.calcOptions.discountIncludesIns) rtn += " - $100 ";
    //   return rtn + ") ";
    // },
    // discountExampleAnswer: function () {
    //   let rtn = 300;
    //   if (this.calcOptions.discountIncludesShipping) rtn += 10;
    //   if (this.calcOptions.discountIncludesIns) rtn -= 100;
    //   rtn = rtn * 0.1;
    //   return rtn;
    // },

    // returns an array of preferences objects [{pref_id:x, value:x}, {...}]
    // for any preference value that is different than the downloaded values
    changedPreferences: function () {
      if (!this.downloadedPrefs) return null;
      let data = this.downloadedPrefs;
      let keys = Object.keys(data);
      let rtn = [];
      keys.forEach((key) => {
        let obj = data[key];
        let dbLabel = obj.label;
        let dbVal = obj.value;
        let formVal =
          dbLabel in this.calcOptions ? this.calcOptions[dbLabel] : null;
        if (dbVal != formVal) rtn.push({ pref_id: key, value: formVal });
      });
      return rtn;
    },
    canSave: function () {
      return this.changedPreferences && this.changedPreferences.length;
    },
  },
  methods: {
    doSave() {
      let items = this.changedPreferences;
      if (!items || !items.length) return; // todo - show "no changes" message, dismiss dialog
      let auth = null;
      if (this.auth_credentials) {
        auth = this.auth_credentials;
      } else {
        alert("Please log in to use this feature");
        return;
      }
      this.loading = true;
      ApiServices.setUserPreferences({ items: items, auth: auth })
        .then((result) => {
          if (result.data.errors) {
            this.errorSnack = true;
            console.log(result.data.errors);
          } else {
            //this.$emit("dismiss"); // if
            if (result.data.prefs) this.downloadedPrefs = result.data.prefs;
            this.populateForm(result.data.prefs);
            this.successSnack = true;
          }
          this.loading = false;
          this.dialog = false;
        })
        .catch((error) => {
          console.log(error);
          this.errorSnack = true;
          this.loading = false;
          this.dialog = false;
        });
    },
    populateForm(data) {
      // console.log(data);
      // let data = this.downloadedPrefs;
      if (!data) return;
      let keys = Object.keys(data);
      let that = this;
      keys.forEach((key) => {
        let obj = data[key];
        let label = obj.label;
        let value = obj.value;
        // console.log(label, value);
        // console.log("label in ", label in that.calcOptions);
        // this.idForPref[label] = key; // just so we can get the pref_id later
        if (value !== null && label && label in that.calcOptions)
          // console.log("setting ", label, value);
          that.calcOptions[label] = value;
      });
      this.$emit("defaultSettings", this.calcOptions);
    },
    updateShowSavings() {
      if (this.calcOptions.showYearCost == 0) this.calcOptions.showSavings = 0;
    },
  },
  mounted() {
    let params = null;
    if (this.auth_credentials) {
      params = this.auth_credentials;
    } else {
      alert("Please log in to use this feature");
      return;
    }
    params.module = "PRICES";
    this.loading = true;
    ApiServices.userPreferences(params)
      .then((response) => {
        if (response.data?.prefs) {
          this.downloadedPrefs = response.data.prefs;
          this.populateForm(response.data.prefs);
        }
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        // this.error = "An API error occurred";
        this.loading = false;
      });
  },
};
</script>

<style scoped>
.columnA {
  max-width: 60%;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.draggableCard {
  cursor: move;
}
</style>
